<script>
  import session from '../../../lib/session';
  import { t9n } from '../../../lib/translate';
  import { TS } from '../../../config/translation-keys';

  export let current_chip;

  let status_header = [
    {
      name: null,
      color: 'var(--order-status-not-approved)',
      chip: 2,
      role: 'orderer',
    },
    {
      name: null,
      color: 'var(--order-status-cancelled-by-orderer)',
      chip: 3,
    },
    {
      name: null,
      color: 'var(--order-status-not-approved)',
      chip: 3,
    },
  ];

  const translate_texts = () => {
    status_header[0].name = t9n(TS.TABLE_HEADER_PAYMENT_FAILED);
    status_header[1].name = t9n(TS.TABLE_COLOR_CANC);
    status_header[2].name = t9n('order_status_not_approved');
  };

  $: if (!!$session) translate_texts();
</script>

{#if current_chip === 3 || current_chip === 2}
  <div class='fade-in' style='display: flex;'>
    {#each status_header as status, i}
      {#if status.chip === current_chip}
        {#if !!status.role}
          {#if status.role === $session.user.last_role}
            <div class='color-square' style={`background: ${status.color}`} />
            {t9n(status.name)}
          {/if}
        {:else}
          <div class='color-square' style={`background: ${status.color}`} />
          {t9n(status.name)}
        {/if}
      {/if}
    {/each}
  </div>
{/if}

<style>
    .color-square {
        width: 10px;
        height: 10px;
        margin: 5px;
        border: 1px solid rgba(0, 0, 0, 0.2);
    }
</style>